// extracted by mini-css-extract-plugin
export default {"DeliveryList":"DeliveryList_DeliveryList__C3+BR"};